import { Box, Button, Divider, Stack, SxProps, Theme } from '@mui/material';
import React from 'react';
import I18n from '../../../i18n/I18n';
import { useReviewApprovalContext } from '../hooks/useReviewApprovalContext';
import ApprovalView from './dataDisplay/ApprovalView';
import ApprovalAction from './dataInput/ApprovalAction';

export interface ReviewApprovalProps {
    sx?: SxProps<Theme>;
}

export default function ReviewApproval({ sx }: ReviewApprovalProps) {
    const {
        isUserAllowedToViewApprovalActions,
        isUserAllowedToExecuteApprovalActions,
        executeApprovalAction,
        isApprovalActionInputValid,
        isExecutingApprovalAction
    } = useReviewApprovalContext();

    return (
        <Stack gap={1.5} px={1} sx={sx} divider={<Divider orientation="horizontal" flexItem />}>
            {isUserAllowedToViewApprovalActions && (
                <Stack gap={1.5}>
                    <Divider orientation="horizontal" flexItem />
                    <ApprovalAction />
                    {isUserAllowedToExecuteApprovalActions && (
                        <Box display={'flex'} justifyContent={'flex-end'}>
                            <Button
                                onClick={executeApprovalAction}
                                disabled={!isApprovalActionInputValid}
                                loading={isExecutingApprovalAction}
                                variant="contained"
                            >
                                <I18n token="common.save" />
                            </Button>
                        </Box>
                    )}
                </Stack>
            )}
            <ApprovalView withCollapsibleSections />
        </Stack>
    );
}
